export const businessTypeDict = {
    0: '其它',
    1: '新增',
    2: '修改',
    3: '删除',
    4: '启用/禁用',
    5: '审核'
}

export const menuIcon = {
    "publicManagement": "el-icon-message-solid",
    "operationsManagement": "el-icon-money",
    "portalManagement": "el-icon-s-platform",
    "SupermarketOperation": "el-icon-shopping-cart-full",
    "community": "el-icon-s-comment",
    "certificationAudit": "el-icon-s-check",
    "resourcesManagement": "el-icon-s-claim",
    "logsManagement": "el-icon-s-order",
    "authorityManagement": "el-icon-setting",
    "user": "el-icon-user-solid",
}


export const reportType = [
    {
        value: 0,
        label: '帖子举报'
    },
    {
        value: 1,
        label: '评论回复举报'
    },
]

export const appTypeDict = [
    {
        value: 'PRODUCE_APP',
        label: '生产制造'
    },
    {
        value: 'ENTERPRISE_APP',
        label: '企业经营'
    },
    {
        value: 'BUILD_DES_APP',
        label: '研发设计'
    },
    {
        value: 'INDUSTRIAL_APP',
        label: '工业视觉应用'
    },
    {
        value: 'MODEL_APP',
        label: '机理模型'
    },
    {
        value: 'OTHER_APP',
        label: '其它'
    }
]

export const appTypeDict2 = [
    {
        value: 1,
        label: '生产制造'
    },
    {
        value: 2,
        label: '企业经营'
    },
    {
        value: 3,
        label: '研发设计'
    },
    {
        value: 4,
        label: '工业视觉应用'
    },
    {
        value: 5,
        label: '机理模型'
    },
    {
        value: 6,
        label: '其它'
    }
]

export const openTimeDict = [
    {
        value: 30,
        label: '30天'
    },
    {
        value: 180,
        label: '180天'
    },
    {
        value: 365,
        label: '365天'
    },
    {
        value: 720,
        label: '720天'
    },
    {
        value: 1095,
        label: '1095天'
    },
    {
        value: 3650,
        label: '3650天'
    },
]

export const trialTimeDict = [
    {
        value: 0,
        label: '0天'
    },
    {
        value: 7,
        label: '7天'
    },
    {
        value: 15,
        label: '15天'
    },
    {
        value: 30,
        label: '30天'
    },
    {
        value: 180,
        label: '180天'
    },
    {
        value: 365,
        label: '365天'
    },
]

export const noticeTypeDict = [
    {
        value: 'DOOR_NOTICE',
        label: '门户公告'
    },
    {
        value: 'APP_NOTICE',
        label: '应用超市公告'
    },
    {
        value: 'OPEN_NOTICE',
        label: '开放平台公告'
    },
]

export const memberTypeDict = {
  0: '普通用户',
  1: '开发者',
  2: '企业管理员',
  3: '服务商',
}

export const appOnLineStatusDict = {
    0: '未上架',
    1: '已上架'
}


export const openVersionDict = {
  0: '试用版',
  1: '正式版',
}

export const payStatusDict = {
    0: '未支付',
    1: '已支付',
    2: '试用中',
    3: '试用已到期',
    4: '待审核',
    5: '已驳回',
}